<div class="page">
  <div class="content-container px-2">
    <div class="center-content-container">
      <div class="admin-page-container" *ngIf="loaded">
        <div class="admin-options mt-4 d-flex align-items-center justify-content-center gap-3 flex-wrap">
          <button
            [ngClass]="{'btn-primary': selectedTab === 'yearly-top-sales', 'btn-outline-primary': selectedTab !== 'yearly-top-sales' }"
            class="btn" (click)="SetTab('yearly-top-sales')">Yearly Top Sales
          </button>
          <button
            [ngClass]="{'btn-primary': selectedTab === 'sold-search', 'btn-outline-primary': selectedTab !== 'sold-search' }"
            class="btn" (click)="SetTab('sold-search')">Sold Search
          </button>
          <button
            [ngClass]="{'btn-primary': selectedTab === 'multiple-sales', 'btn-outline-primary': selectedTab !== 'multiple-sales' }"
            class="btn" (click)="SetTab('multiple-sales')">Multiple Sales
          </button>
          <button [ngClass]="{'btn-primary': selectedTab === 'blog', 'btn-outline-primary': selectedTab !== 'blog' }"
                  class="btn" (click)="SetTab('blog')">Create Blogs
          </button>
          <button
            [ngClass]="{'btn-primary': selectedTab === 'blog-config', 'btn-outline-primary': selectedTab !== 'blog-config' }"
            class="btn" (click)="SetTab('blog-config')">Blog Config
          </button>
          <button
            [ngClass]="{'btn-primary': selectedTab === 'static-media', 'btn-outline-primary': selectedTab !== 'static-media' }"
            class="btn" (click)="SetTab('static-media')">Media
          </button>
          <button
            [ngClass]="{'btn-primary': selectedTab === 'recently-added', 'btn-outline-primary': selectedTab !== 'recently-added' }"
            class="btn" (click)="SetTab('recently-added')">Recently Added Plates
          </button>
          <button
            [ngClass]="{'btn-primary': selectedTab === 'viewer-config', 'btn-outline-primary': selectedTab !== 'viewer-config' }"
            class="btn" (click)="SetTab('viewer-config')">Plate Viewer
          </button>
          <button [ngClass]="{'btn-primary': selectedTab === 'gpt', 'btn-outline-primary': selectedTab !== 'gpt' }"
                  class="btn" (click)="SetTab('gpt')">GPT Search
          </button>
          <button
            [ngClass]="{'btn-primary': selectedTab === 'wordbank', 'btn-outline-primary': selectedTab !== 'wordbank' }"
            class="btn" (click)="SetTab('wordbank')">Wordbank
          </button>
          <button
            [ngClass]="{'btn-primary': selectedTab === 'users', 'btn-outline-primary': selectedTab !== 'users' }"
            class="btn" (click)="SetTab('users')">Users
          </button>
          <button
            [ngClass]="{'btn-primary': selectedTab === 'dealer-health', 'btn-outline-primary': selectedTab !== 'dealer-health' }"
            class="btn" (click)="SetTab('dealer-health')">Dealer Health
          </button>
          <button
            [ngClass]="{'btn-primary': selectedTab === 'editorial', 'btn-outline-primary': selectedTab !== 'editorial' }"
            class="btn" (click)="SetTab('editorial')">Editorial Review
          </button>
        </div>

        <!-- tabs -->
        <div class="mb-3 mt-5">
          <pla-admin-yearly-top-sales *ngIf="selectedTab === 'yearly-top-sales'"></pla-admin-yearly-top-sales>
          <pla-admin-sold-search *ngIf="selectedTab === 'sold-search'"></pla-admin-sold-search>
          <pla-admin-multiple-sales *ngIf="selectedTab === 'multiple-sales'"></pla-admin-multiple-sales>
          <pla-admin-blog-create *ngIf="selectedTab === 'blog'"></pla-admin-blog-create>
          <pla-admin-blog-config *ngIf="selectedTab === 'blog-config'"></pla-admin-blog-config>
          <pla-admin-static-media *ngIf="selectedTab === 'static-media'"></pla-admin-static-media>
          <pla-admin-recently-added *ngIf="selectedTab === 'recently-added'"></pla-admin-recently-added>
          <pla-admin-plate-viewer-toggle *ngIf="selectedTab === 'viewer-config'"></pla-admin-plate-viewer-toggle>
          <pla-admin-gpt *ngIf="selectedTab === 'gpt'"></pla-admin-gpt>
          <pla-admin-wordbank *ngIf="selectedTab === 'wordbank'"></pla-admin-wordbank>
          <pla-admin-users *ngIf="selectedTab === 'users'"></pla-admin-users>
          <pla-admin-dealer-health *ngIf="selectedTab === 'dealer-health'"></pla-admin-dealer-health>
          <pla-admin-editorial-review *ngIf="selectedTab === 'editorial'"></pla-admin-editorial-review>
        </div>
      </div>
    </div>
  </div>
</div>
